import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class PersonneMoraleModificationList extends ShadowDOMElement {
	static className = "PersonneMoraleModificationList";
	
	static properties = {
		title: {type: String, attribute: "title" },
		labelAddButton: { type: String, attribute: "label-add-button"},
		showReplacement: { type: Boolean, attribute: "show-replacement",
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		showRepresentative: { type: Boolean, attribute: "show-representative",
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		showRegistrationLocation: { type: Boolean, attribute: "show-registration-location",
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		showRegistrationNumber: { type: Boolean, attribute: "show-registration-number",
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}		
	};

	constructor() {
		super();
		this.managers = [];
		this.title = "Administrateur";
		this.labelAddButton = "Ajouter une personne morale";
		
		this.showReplacement = false;
		this.showRepresentative = false;
		this.showRegistrationLocation = true;
		this.showRegistrationNumber = true;
	}

	firstUpdated() {
		super.firstUpdated();
		this.addManager();
	}

	addManager() {
		const managerContainer = document.createElement("personne-morale-modification");
		managerContainer.setAttribute("show-replacement", this.showReplacement);
		managerContainer.setAttribute("show-representative", this.showRepresentative);
		managerContainer.setAttribute("show-registration-location", this.showRegistrationLocation);
		managerContainer.setAttribute("show-registration-number", this.showRegistrationNumber);

		if (this.managers.length > 0) {
			const deleteButtonWrapper = this.createDeleteButton(managerContainer);
			this.appendChild (deleteButtonWrapper);
		}

		this.managers.push (managerContainer);
		this.appendChild (managerContainer);
	}

	removeManager(managerContainer, deleteButtonWrapper) {
		this.managers = this.managers.filter((manager) => manager !== managerContainer);
		this.removeChild (managerContainer);
		if (deleteButtonWrapper)
			this.removeChild (deleteButtonWrapper);
	}

	createDeleteButton(managerContainer) {
		const deleteButtonWrapper = document.createElement("row-wrapper");
		const deleteButton = document.createElement("button-field");

		deleteButton.onClickHandler = () => {
			this.removeManager(managerContainer, deleteButtonWrapper);
		};

		deleteButton.innerHTML = `<i class="fa fa-minus"></i><span>&nbsp;Supprimer</span>`;
		deleteButtonWrapper.appendChild(deleteButton);

		return deleteButtonWrapper;
	}

	render() {
		return html`
		<row-wrapper>
			<subtitle-field label="${this.title}"></subtitle-field>
		</row-wrapper>
		<slot></slot>
		<row-wrapper data-add-button="true">
			<button-field .onClickHandler="${this.addManager.bind(this)}">
				<i class="fa fa-plus"></i><span>&nbsp;${this.labelAddButton}</span>
			</button-field>
		</row-wrapper>
	    `;
	}
	
	isTransient (){
		return false;
	}
	
	getValues (){
		return {
			"count" : this.managers.length || 1,
			... super.getValues ()
		}
	}

	setValues (values){
		while (this.managers.length < values.count)
	        this.addManager ();
		super.setValues (values);
	}
}

customElements.define("personne-morale-modification-list", PersonneMoraleModificationList);
